import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, HostListener, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[vmRouting]',
  standalone: true,
})
export class RoutingDirective {
  @HostListener('click', ['$event'])
  onClick(e: Event) {
    this.navigate();
    e.preventDefault();
  }

  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  element = inject(ElementRef);
  router = inject(Router);

  async navigate() {
    const href = this.element.nativeElement.href;
    try {
      const url = new URL(href);
      if (this.isBrowser) {
        if (url.pathname === '/' || url.hostname !== window.location.hostname) {
          location.assign(href);
        } else {
          try {
            await this.router.navigateByUrl(url.pathname);
          } catch (e) {
            location.assign(href);
          }
        }
      }
    } catch (e) {
      try {
        await this.router.navigateByUrl(href);
      } catch (e) {
        location.assign(href);
      }
    }
  }
}
